import { BadgeCheck } from "lucide-react";

export function FundingReadyBadge({ ready, testid = "funding-ready-badge" }) {
  if (!ready) return null;
  return (
    <span className="inline-flex items-center gap-1.5 bg-emerald-600 text-white text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full" data-testid={testid}>
      <BadgeCheck className="h-4 w-4" />Funding Ready · 100% verified
    </span>
  );
}
